import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ElpriserIdag = lazy(() => import("@/pages/elpriser/Idag"));

export const Route = createFileRoute("/elpriser/idag")({
  head: () => seoHead("/elpriser/idag", { description: "Se dagens elpriser timme för timme i SE1, SE2, SE3 och SE4. Priserna kommer från Nord Pool och uppdateras automatiskt." }),
  component: () => <ElpriserIdag />,
});
